import React from 'react';
import { Outlet } from 'react-router-dom';

const Women = () => {
  return <Outlet />;
};

export default Women;
